// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
import { z } from "zod";

/** Search params for the channel URL: the open thread. */
export const chatSearch = z.object({ thread: z.string().optional(), view: z.literal("saved").optional() });
export type ChatSearch = z.infer<typeof chatSearch>;
